(function () {
  function init() {
    var sidebar = document.querySelector('[data-japow-sidebar]');
    var scrollCtas = document.querySelectorAll('[data-japow-scroll-cta]');

    // How much of the top of the viewport is covered once you scroll: the theme's sticky
    // header (logo + search on mobile), plus the JAPOW section nav when it's a horizontal
    // bar across the top (mobile). Applied as scroll-margin-top so every jump to a section
    // (side nav, CTAs, #hash links from emails, the Build Your System re-scroll) lands
    // with its heading visible instead of tucked under the header.
    function japowScrollOffset() {
      var vw = window.innerWidth, vh = window.innerHeight, cover = 0;
      document.querySelectorAll('body > *, body > * > *, body > * > * > *').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        var top = parseFloat(cs.top);
        if (isNaN(top) || top > 5) return;
        var h = el.offsetHeight;
        if (!h || h > vh * 0.4 || el.offsetWidth < vw * 0.6) return;
        if (el.closest('[data-japow-sidebar]')) return;
        cover = Math.max(cover, top + h);
      });
      if (sidebar && sidebar.offsetWidth > vw * 0.6) cover += sidebar.offsetHeight;
      return Math.round(cover + 12);
    }

    // Sections have very different top padding (dark panels add extra), so aligning the
    // section box itself leaves anything from ~70px to ~200px of empty space under the nav.
    // Align the section's heading (eyebrow label if it has one, else the h2) instead, so
    // every jump lands with the heading the same distance below the header/nav.
    function scrollAnchor(section) {
      return section.querySelector('.japow-section__eyebrow, h2') || section;
    }

    function applyScrollMargins() {
      var offset = japowScrollOffset();
      document.querySelectorAll('.japow-section[id]').forEach(function (el) {
        el.style.scrollMarginTop = offset + 'px';
        var anchor = scrollAnchor(el);
        if (anchor !== el) anchor.style.scrollMarginTop = (offset + 12) + 'px';
      });
      var signup = document.getElementById('JapowChecklistSignup');
      if (signup) signup.style.scrollMarginTop = (offset + 12) + 'px';
    }

    applyScrollMargins();
    window.addEventListener('resize', applyScrollMargins);
    window.addEventListener('load', function () {
      applyScrollMargins();
      // Arriving from a link like /pages/japow-hub#shop-bundles: the browser jumped before
      // the margin existed, so re-align once it's in place.
      var hashTarget = window.location.hash && document.getElementById(window.location.hash.slice(1));
      if (hashTarget && hashTarget.classList.contains('japow-section')) {
        scrollAnchor(hashTarget).scrollIntoView({ block: 'start' });
      } else if (hashTarget && hashTarget.id === 'JapowChecklistSignup') {
        hashTarget.scrollIntoView({ block: 'start' });
      }
    });

    scrollCtas.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          applyScrollMargins();
          (target.classList.contains('japow-section') ? scrollAnchor(target) : target).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Resort Guides: filter bar toggles which resort cards are visible, and
    // the last "Interactive Map" button swaps the whole grid out for a
    // map-with-hover-panel view instead of filtering by tag.
    var resortFilterBar = document.querySelector('[data-japow-resort-filters]');
    var resortGrid = document.querySelector('[data-japow-resort-grid]');
    if (resortFilterBar && resortGrid) {
      var resortCards = Array.prototype.slice.call(resortGrid.querySelectorAll('.japow-resort-card'));
      var resortMap = document.querySelector('[data-japow-resort-map]');
      var mapGraphic = resortMap ? resortMap.querySelector('.japow-map__graphic') : null;
      var mapPanel = resortMap ? resortMap.querySelector('[data-japow-map-panel]') : null;
      var mapPanelContent = resortMap ? resortMap.querySelector('[data-japow-map-content]') : null;
      var mapClose = resortMap ? resortMap.querySelector('[data-japow-map-close]') : null;
      var mapBackdrop = resortMap ? resortMap.querySelector('[data-japow-map-backdrop]') : null;
      var mapTemplatesWrap = document.querySelector('[data-japow-map-templates]');
      var mapPins = resortMap ? Array.prototype.slice.call(resortMap.querySelectorAll('.japow-map__pin')) : [];
      var mapTemplates = mapTemplatesWrap ? Array.prototype.slice.call(mapTemplatesWrap.querySelectorAll('template')) : [];

      var canHoverMap = false;
      try {
        canHoverMap = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      } catch (err) {
        canHoverMap = true;
      }

      function templateForResort(index) {
        for (var i = 0; i < mapTemplates.length; i++) {
          if (mapTemplates[i].getAttribute('data-resort-index') === String(index)) return mapTemplates[i];
        }
        return null;
      }

      // On mobile the panel becomes a fixed, centered overlay with a dimmed
      // backdrop (see the .is-open rules in japow-resort-map.css) so a tapped
      // resort is never rendered off-screen below the map. On desktop these
      // classes have no matching CSS outside that mobile breakpoint, so
      // adding them on every selection (mouse or touch alike) is harmless.
      //
      // Both elements start out nested inside .japow-map / the section
      // wrapper. If anything further up the page ever has (or gains) a CSS
      // transform on it — a common scroll-reveal technique — that ancestor
      // silently becomes the containing block for our position:fixed panel
      // and backdrop instead of the viewport, which would shrink and clip
      // the "full screen" overlay to that ancestor's box: the card can end
      // up floating in the right general area while its close button and
      // the backdrop's tap-to-dismiss region are cropped away or displaced.
      // Re-parenting both elements to <body> for the lifetime of the mobile
      // overlay sidesteps that class of bug entirely rather than relying on
      // every ancestor staying transform-free forever.
      var mapOverlayPortaled = false;

      function isMobileMapOverlay() {
        try {
          return window.matchMedia('(max-width: 900px)').matches;
        } catch (err) {
          return false;
        }
      }

      function portalMapOverlay() {
        if (mapOverlayPortaled || !mapPanel || !mapBackdrop || !resortMap) return;
        document.body.appendChild(mapBackdrop);
        document.body.appendChild(mapPanel);
        mapOverlayPortaled = true;
      }

      function unportalMapOverlay() {
        if (!mapOverlayPortaled || !mapPanel || !mapBackdrop || !resortMap) return;
        // .japow-map__graphic stays put the whole time, so re-appending in
        // this order restores the original graphic → panel → backdrop
        // sequence inside .japow-map.
        resortMap.appendChild(mapPanel);
        resortMap.appendChild(mapBackdrop);
        mapOverlayPortaled = false;
      }

      function openMapPanel() {
        if (isMobileMapOverlay()) portalMapOverlay();
        if (mapPanel) mapPanel.classList.add('is-open');
        if (mapBackdrop) mapBackdrop.classList.add('is-open');
      }

      function closeMapPanel() {
        if (mapPanel) mapPanel.classList.remove('is-open');
        if (mapBackdrop) mapBackdrop.classList.remove('is-open');
        unportalMapOverlay();
      }

      // If the viewport widens past the mobile breakpoint while the overlay
      // is open (rotating a tablet, resizing a browser window), close it
      // rather than leaving a portaled, position:fixed panel sitting over a
      // now-desktop layout it was never styled for.
      window.addEventListener('resize', function () {
        if (mapOverlayPortaled && !isMobileMapOverlay()) closeMapPanel();
      });

      if (mapClose) mapClose.addEventListener('click', closeMapPanel);
      if (mapBackdrop) mapBackdrop.addEventListener('click', closeMapPanel);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMapPanel();
      });

      function showResortInPanel(pin) {
        if (!mapPanelContent) return;
        var index = pin.getAttribute('data-resort-index');
        var tpl = templateForResort(index);
        if (!tpl) return;

        mapPins.forEach(function (p) {
          p.classList.toggle('is-active', p === pin);
        });

        mapPanelContent.innerHTML = '';
        mapPanelContent.appendChild(tpl.content.cloneNode(true));

        openMapPanel();
      }

      mapPins.forEach(function (pin) {
        if (canHoverMap) {
          pin.addEventListener('mouseenter', function () {
            showResortInPanel(pin);
          });
        }
        pin.addEventListener('focus', function () {
          showResortInPanel(pin);
        });
        pin.addEventListener('click', function (e) {
          e.preventDefault();
          showResortInPanel(pin);
        });
      });

      // Pins that sit too close together to tap accurately (e.g. the Nagano
      // cluster) collapse into one numbered badge; tapping/clicking it opens
      // a small menu to pick which of those resorts to view. Distance is
      // measured in the graphic's own percent coordinates, with the y-axis
      // rescaled by its aspect ratio (823/480) first — a 1% step vertically
      // covers more real pixels than a 1% step horizontally on this portrait
      // map, so comparing raw percents would under-group vertically-spread
      // pins and over-group horizontally-spread ones.
      if (mapGraphic && mapPins.length > 1) {
        var CLUSTER_Y_SCALE = 823 / 480;
        var CLUSTER_THRESHOLD = 6;

        var pinData = mapPins.map(function (pin) {
          return {
            el: pin,
            x: parseFloat(pin.getAttribute('data-pin-x')) || 50,
            y: parseFloat(pin.getAttribute('data-pin-y')) || 50
          };
        });

        function pinDist2(a, b) {
          var dx = a.x - b.x;
          var dy = (a.y - b.y) * CLUSTER_Y_SCALE;
          return dx * dx + dy * dy;
        }

        function closeAllClusterMenus() {
          Array.prototype.slice.call(mapGraphic.querySelectorAll('.japow-map__cluster-menu')).forEach(function (m) {
            m.hidden = true;
          });
          Array.prototype.slice.call(mapGraphic.querySelectorAll('.japow-map__cluster')).forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        }

        var visited = pinData.map(function () { return false; });
        var groups = [];
        pinData.forEach(function (_, i) {
          if (visited[i]) return;
          var group = [i];
          visited[i] = true;
          var queue = [i];
          while (queue.length) {
            var cur = queue.pop();
            pinData.forEach(function (_, j) {
              if (visited[j]) return;
              if (pinDist2(pinData[cur], pinData[j]) <= CLUSTER_THRESHOLD * CLUSTER_THRESHOLD) {
                visited[j] = true;
                group.push(j);
                queue.push(j);
              }
            });
          }
          groups.push(group);
        });

        groups.forEach(function (group) {
          if (group.length < 2) return;

          var members = group.map(function (i) { return pinData[i]; });
          var cx = members.reduce(function (sum, m) { return sum + m.x; }, 0) / members.length;
          var cy = members.reduce(function (sum, m) { return sum + m.y; }, 0) / members.length;

          members.forEach(function (m) { m.el.hidden = true; });

          var badge = document.createElement('button');
          badge.type = 'button';
          badge.className = 'japow-map__cluster';
          badge.style.left = cx + '%';
          badge.style.top = cy + '%';
          badge.setAttribute('aria-haspopup', 'true');
          badge.setAttribute('aria-expanded', 'false');
          badge.setAttribute('aria-label', members.length + ' resorts in this area');
          badge.innerHTML = '<span class="japow-map__cluster-count">' + members.length + '</span>';

          var menu = document.createElement('div');
          menu.className = 'japow-map__cluster-menu';
          menu.hidden = true;
          menu.style.left = cx + '%';
          menu.style.top = cy + '%';

          members
            .slice()
            .sort(function (a, b) {
              return (a.el.getAttribute('data-pin-name') || '').localeCompare(b.el.getAttribute('data-pin-name') || '');
            })
            .forEach(function (m) {
              var item = document.createElement('button');
              item.type = 'button';
              item.className = 'japow-map__cluster-menu-item';
              item.textContent = m.el.getAttribute('data-pin-name') || 'Resort';
              item.addEventListener('click', function (e) {
                e.stopPropagation();
                closeAllClusterMenus();
                showResortInPanel(m.el);
              });
              menu.appendChild(item);
            });

          badge.addEventListener('click', function (e) {
            e.stopPropagation();
            var isOpen = !menu.hidden;
            closeAllClusterMenus();
            if (!isOpen) {
              menu.hidden = false;
              badge.setAttribute('aria-expanded', 'true');
            }
          });

          mapGraphic.appendChild(badge);
          mapGraphic.appendChild(menu);
        });

        document.addEventListener('click', closeAllClusterMenus);
      }

      resortFilterBar.addEventListener('click', function (e) {
        var btn = e.target.closest('.japow-resort-filter');
        if (!btn) return;

        Array.prototype.slice.call(resortFilterBar.querySelectorAll('.japow-resort-filter')).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        var mapToggle = btn.getAttribute('data-view-toggle') === 'map';

        if (mapToggle) {
          if (resortMap) resortMap.hidden = false;
          resortGrid.hidden = true;
          return;
        }

        if (resortMap) resortMap.hidden = true;
        resortGrid.hidden = false;

        var filter = btn.getAttribute('data-filter');
        resortCards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split(',');
          var show = filter === 'all' || tags.indexOf(filter) !== -1;
          card.classList.toggle('is-hidden', !show);
        });
      });
    }

    // Food & Après: same tag-based filter pattern as Resort Guides, but no map
    // toggle — this section is a simple card grid. Uses its own data-
    // attributes (not data-japow-resort-filters/-grid) so this querySelector
    // doesn't just re-find the Resort Guides section above it.
    var foodFilterBar = document.querySelector('[data-japow-food-filters]');
    var foodGrid = document.querySelector('[data-japow-food-grid]');
    if (foodFilterBar && foodGrid) {
      var foodCards = Array.prototype.slice.call(foodGrid.querySelectorAll('.japow-resort-card'));

      foodFilterBar.addEventListener('click', function (e) {
        var btn = e.target.closest('.japow-resort-filter');
        if (!btn) return;

        Array.prototype.slice.call(foodFilterBar.querySelectorAll('.japow-resort-filter')).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        var filter = btn.getAttribute('data-filter');
        foodCards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split(',');
          var show = filter === 'all' || tags.indexOf(filter) !== -1;
          card.classList.toggle('is-hidden', !show);
        });
      });
    }

    // Packing List: interactive checklist with progress counter + check-all toggle
    var checklistWrap = document.querySelector('[data-japow-checklist]');
    if (checklistWrap) {
      var checklistToggle = document.querySelector('[data-japow-checklist-toggle]');
      var checklistProgress = document.querySelector('[data-japow-checklist-progress]');

      var checklistItemEls = function () {
        return Array.prototype.slice.call(checklistWrap.querySelectorAll('.japow-checklist-item'));
      };

      var updateChecklistProgress = function () {
        var items = checklistItemEls();
        var checked = items.filter(function (i) {
          return i.querySelector('input').checked;
        }).length;
        if (checklistProgress) {
          checklistProgress.textContent = checked + ' / ' + items.length + ' packed';
        }
        if (checklistToggle) {
          checklistToggle.textContent = items.length && checked === items.length ? 'Uncheck All' : 'Check All';
        }
      };

      checklistWrap.addEventListener('change', function (e) {
        if (e.target.type !== 'checkbox') return;
        e.target.closest('.japow-checklist-item').classList.toggle('is-checked', e.target.checked);
        updateChecklistProgress();
      });

      if (checklistToggle) {
        checklistToggle.addEventListener('click', function () {
          var items = checklistItemEls();
          var allChecked = items.length > 0 && items.every(function (i) {
            return i.querySelector('input').checked;
          });
          items.forEach(function (i) {
            var input = i.querySelector('input');
            input.checked = !allChecked;
            i.classList.toggle('is-checked', !allChecked);
          });
          updateChecklistProgress();
        });
      }

      updateChecklistProgress();
    }

    if (!sidebar) return;

    var navLinks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-japow-link]'));
    var targets = navLinks
      .map(function (a) { return document.getElementById(a.getAttribute('data-japow-link')); })
      .filter(Boolean);
    if (!targets.length) return;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function setActive(id) {
      navLinks.forEach(function (a) {
        var li = a.closest('li');
        if (!li) return;
        var active = a.getAttribute('data-japow-link') === id;
        li.classList.toggle('is-active', active);
        if (active && isMobile()) {
          li.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    targets.forEach(function (t) { observer.observe(t); });

    // Position logic: behaves like native `position: sticky`, computed in JS
    // because the sidebar-nav section and content sections are independent
    // Shopify sections with no shared parent that native sticky could anchor
    // to. We track a reference point and keep the bar's fixed "top" tracking
    // scroll 1:1 until it would cross the stuck line, then clamp it there.
    //
    // On desktop, the reference is the Traveller Hub HEADING itself, so the
    // sidebar visually arrives level with the title text (not the "Section 1"
    // label above it). On mobile it's a horizontal bar, not a sidebar sitting
    // next to content, so the reference is the top of the section instead —
    // i.e. it should catch and lock in almost immediately once the hero
    // banner ends, sitting right under it rather than trailing down further.
    var firstTargetAbsoluteTop = 0;

    function computeAbsoluteTop() {
      if (isMobile()) {
        return targets[0].getBoundingClientRect().top + window.scrollY;
      }
      var headingEl = targets[0].querySelector('h2') || targets[0];
      return headingEl.getBoundingClientRect().top + window.scrollY;
    }

    function stuckTop() {
      var headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 80;
      return isMobile() ? headerHeight : headerHeight + 24;
    }

    function updatePosition() {
      var top = Math.max(stuckTop(), firstTargetAbsoluteTop - window.scrollY);
      sidebar.style.top = top + 'px';
      sidebar.classList.add('is-ready');
    }

    firstTargetAbsoluteTop = computeAbsoluteTop();
    updatePosition();

    window.addEventListener('scroll', updatePosition, { passive: true });
    window.addEventListener('resize', function () {
      firstTargetAbsoluteTop = computeAbsoluteTop();
      updatePosition();
    });

    navLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(a.getAttribute('data-japow-link'));
        if (target) {
          applyScrollMargins();
          (target.classList.contains('japow-section') ? scrollAnchor(target) : target).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
